"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Row = exports.Box = exports.display = exports.cursor = exports.position = exports.flex = exports.overflow = exports.spacing = exports.xs = exports.sm = exports.md = exports.lg = exports.xl = exports.xxl = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyleGuide = require("../StyleGuide");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
Bootstrap style responsive grid system

xs (0px and up): 4 columns
sm (375px and up): 4 columns
md (768px and up): 8 columns
lg (1024px and up): 12 columns
xl (1440px and up): 12 columns
xxl (1920px and up): 12 columns

Column span per row must add up to the total number of columns for a given screen size.

<Container fullWidth>
  <Row>
    <Box xs={4} md={4} lg={8} />
    <Box xs={4} md={4} lg={4} />
  </Row>
</Container>
*/

/* Column span widths */
var xxl = (0, _styledComponents.css)(["@media (min-width:", "px){width:", ";}"], function (props) {
  return props.theme.responsiveDesktopXl;
}, function (props) {
  return props.xxl && "".concat(props.xxl / 12 * 100, "%");
});
exports.xxl = xxl;
var xl = (0, _styledComponents.css)(["@media (min-width:", "px){width:", ";}"], function (props) {
  return props.theme.responsiveDesktop;
}, function (props) {
  return props.xl && "".concat(props.xl / 12 * 100, "%");
});
exports.xl = xl;
var lg = (0, _styledComponents.css)(["@media (min-width:", "px){width:", ";}"], function (props) {
  return props.theme.responsiveLarge;
}, function (props) {
  return props.lg && "".concat(props.lg / 12 * 100, "%");
});
exports.lg = lg;
var md = (0, _styledComponents.css)(["@media (min-width:", "px){width:", ";}"], function (props) {
  return props.theme.responsiveMedium;
}, function (props) {
  return props.md && "".concat(props.md / 8 * 100, "%");
});
exports.md = md;
var sm = (0, _styledComponents.css)(["@media (min-width:", "px){width:", ";}"], function (props) {
  return props.theme.responsiveSmall;
}, function (props) {
  return props.sm && "".concat(props.sm / 4 * 100, "%");
});
exports.sm = sm;
var xs = (0, _styledComponents.css)(["@media (min-width:0px){width:", ";}"], function (props) {
  return props.xs && "".concat(props.xs / 4 * 100, "%");
});
/* Spacing */

exports.xs = xs;
var spacing = (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.p && (0, _styledComponents.css)(["padding:", ";"], props.p === 'xxs' && props.theme.spacingXxs || props.p === 'xs' && props.theme.spacingXs || props.p === 'sm' && props.theme.spacingSm || props.p === 'md' && props.theme.spacingMd || props.p === 'lg' && props.theme.spacingLg || props.p === 'xl' && props.theme.spacingXl || props.p);
}, function (props) {
  return props.px && (0, _styledComponents.css)(["padding-left:", ";padding-right:", ";"], props.px === 'xxs' && props.theme.spacingXxs || props.px === 'xs' && props.theme.spacingXs || props.px === 'sm' && props.theme.spacingSm || props.px === 'md' && props.theme.spacingMd || props.px === 'lg' && props.theme.spacingLg || props.px === 'xl' && props.theme.spacingXl || props.px === 'xxl' && props.theme.spacingXxl || props.px, props.px === 'xxs' && props.theme.spacingXxs || props.px === 'xs' && props.theme.spacingXs || props.px === 'sm' && props.theme.spacingSm || props.px === 'md' && props.theme.spacingMd || props.px === 'lg' && props.theme.spacingLg || props.px === 'xl' && props.theme.spacingXl || props.px === 'xxl' && props.theme.spacingXxl || props.px);
}, function (props) {
  return props.py && (0, _styledComponents.css)(["padding-top:", ";padding-bottom:", ";"], props.py === 'xxs' && props.theme.spacingXxs || props.py === 'xs' && props.theme.spacingXs || props.py === 'sm' && props.theme.spacingSm || props.py === 'md' && props.theme.spacingMd || props.py === 'lg' && props.theme.spacingLg || props.py === 'xl' && props.theme.spacingXl || props.py === 'xxl' && props.theme.spacingXxl || props.py, props.py === 'xxs' && props.theme.spacingXxs || props.py === 'xs' && props.theme.spacingXs || props.py === 'sm' && props.theme.spacingSm || props.py === 'md' && props.theme.spacingMd || props.py === 'lg' && props.theme.spacingLg || props.py === 'xl' && props.theme.spacingXl || props.py === 'xxl' && props.theme.spacingXxl || props.py);
}, function (props) {
  return props.pl && (0, _styledComponents.css)(["padding-left:", ";"], props.pl === 'xxs' && props.theme.spacingXxs || props.pl === 'xs' && props.theme.spacingXs || props.pl === 'sm' && props.theme.spacingSm || props.pl === 'md' && props.theme.spacingMd || props.pl === 'lg' && props.theme.spacingLg || props.pl === 'xl' && props.theme.spacingXl || props.pl === 'xxl' && props.theme.spacingXxl || props.pl);
}, function (props) {
  return props.pr && (0, _styledComponents.css)(["padding-right:", ";"], props.pr === 'xxs' && props.theme.spacingXxs || props.pr === 'xs' && props.theme.spacingXs || props.pr === 'sm' && props.theme.spacingSm || props.pr === 'md' && props.theme.spacingMd || props.pr === 'lg' && props.theme.spacingLg || props.pr === 'xl' && props.theme.spacingXl || props.pr === 'xxl' && props.theme.spacingXxl || props.pr);
}, function (props) {
  return props.pt && (0, _styledComponents.css)(["padding-top:", ";"], props.pt === 'xxs' && props.theme.spacingXxs || props.pt === 'xs' && props.theme.spacingXs || props.pt === 'sm' && props.theme.spacingSm || props.pt === 'md' && props.theme.spacingMd || props.pt === 'lg' && props.theme.spacingLg || props.pt === 'xl' && props.theme.spacingXl || props.pt === 'xxl' && props.theme.spacingXxl || props.pt);
}, function (props) {
  return props.pb && (0, _styledComponents.css)(["padding-bottom:", ";"], props.pb === 'xxs' && props.theme.spacingXxs || props.pb === 'xs' && props.theme.spacingXs || props.pb === 'sm' && props.theme.spacingSm || props.pb === 'md' && props.theme.spacingMd || props.pb === 'lg' && props.theme.spacingLg || props.pb === 'xl' && props.theme.spacingXl || props.pb === 'xxl' && props.theme.spacingXxl || props.pb);
}, function (props) {
  return props.m && (0, _styledComponents.css)(["margin:", ";"], props.m === 'xxs' && props.theme.spacingXxs || props.m === 'xs' && props.theme.spacingXs || props.m === 'sm' && props.theme.spacingSm || props.m === 'md' && props.theme.spacingMd || props.m === 'lg' && props.theme.spacingLg || props.m === 'xl' && props.theme.spacingXl || props.m === 'xxl' && props.theme.spacingXxl || props.m);
}, function (props) {
  return props.mx && (0, _styledComponents.css)(["margin-left:", ";margin-right:", ";"], props.mx === 'xxs' && props.theme.spacingXxs || props.mx === 'xs' && props.theme.spacingXs || props.mx === 'sm' && props.theme.spacingSm || props.mx === 'md' && props.theme.spacingMd || props.mx === 'lg' && props.theme.spacingLg || props.mx === 'xl' && props.theme.spacingXl || props.mx === 'xxl' && props.theme.spacingXxl || props.mx, props.mx === 'xxs' && props.theme.spacingXxs || props.mx === 'xs' && props.theme.spacingXs || props.mx === 'sm' && props.theme.spacingSm || props.mx === 'md' && props.theme.spacingMd || props.mx === 'lg' && props.theme.spacingLg || props.mx === 'xl' && props.theme.spacingXl || props.mx === 'xxl' && props.theme.spacingXxl || props.mx);
}, function (props) {
  return props.my && (0, _styledComponents.css)(["margin-top:", ";margin-bottom:", ";"], props.my === 'xxs' && props.theme.spacingXxs || props.my === 'xs' && props.theme.spacingXs || props.my === 'sm' && props.theme.spacingSm || props.my === 'md' && props.theme.spacingMd || props.my === 'lg' && props.theme.spacingLg || props.my === 'xl' && props.theme.spacingXl || props.my === 'xxl' && props.theme.spacingXxl || props.my, props.my === 'xxs' && props.theme.spacingXxs || props.my === 'xs' && props.theme.spacingXs || props.my === 'sm' && props.theme.spacingSm || props.my === 'md' && props.theme.spacingMd || props.my === 'lg' && props.theme.spacingLg || props.my === 'xl' && props.theme.spacingXl || props.my === 'xxl' && props.theme.spacingXxl || props.my);
}, function (props) {
  return props.mt && (0, _styledComponents.css)(["margin-top:", ";"], props.mt === 'xxs' && props.theme.spacingXxs || props.mt === 'xs' && props.theme.spacingXs || props.mt === 'sm' && props.theme.spacingSm || props.mt === 'md' && props.theme.spacingMd || props.mt === 'lg' && props.theme.spacingLg || props.mt === 'xl' && props.theme.spacingXl || props.mt === 'xxl' && props.theme.spacingXxl || props.mt);
}, function (props) {
  return props.mb && (0, _styledComponents.css)(["margin-bottom:", ";"], props.mb === 'xxs' && props.theme.spacingXxs || props.mb === 'xs' && props.theme.spacingXs || props.mb === 'sm' && props.theme.spacingSm || props.mb === 'md' && props.theme.spacingMd || props.mb === 'lg' && props.theme.spacingLg || props.mb === 'xl' && props.theme.spacingXl || props.mb === 'xxl' && props.theme.spacingXxl || props.mb);
}, function (props) {
  return props.ml && (0, _styledComponents.css)(["margin-left:", ";"], props.ml === 'xxs' && props.theme.spacingXxs || props.ml === 'xs' && props.theme.spacingXs || props.ml === 'sm' && props.theme.spacingSm || props.ml === 'md' && props.theme.spacingMd || props.ml === 'lg' && props.theme.spacingLg || props.ml === 'xl' && props.theme.spacingXl || props.ml === 'xxl' && props.theme.spacingXxl || props.ml);
}, function (props) {
  return props.mr && (0, _styledComponents.css)(["margin-right:", ";"], props.mr === 'xxs' && props.theme.spacingXxs || props.mr === 'xs' && props.theme.spacingXs || props.mr === 'sm' && props.theme.spacingSm || props.mr === 'md' && props.theme.spacingMd || props.mr === 'lg' && props.theme.spacingLg || props.mr === 'xl' && props.theme.spacingXl || props.mr === 'xxl' && props.theme.spacingXxl || props.mr);
});
exports.spacing = spacing;
var overflow = (0, _styledComponents.css)(["", " ", ""], function (props) {
  return props.singleLineText && (0, _styledComponents.css)(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;hyphens:none;"]);
}, function (props) {
  return props.noWrap && (0, _styledComponents.css)(["white-space:nowrap;"]);
});
/* Basic flexbox types */

exports.overflow = overflow;
var flex = (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.justify === 'left' && (0, _styledComponents.css)(["justify-content:flex-start;"]);
}, function (props) {
  return props.justify === 'right' && (0, _styledComponents.css)(["justify-content:flex-end;"]);
}, function (props) {
  return props.justify === 'center' && (0, _styledComponents.css)(["justify-content:center;"]);
}, function (props) {
  return props.justify === 'space-between' && (0, _styledComponents.css)(["justify-content:space-between;"]);
}, function (props) {
  return props.justify === 'space-evenly' && (0, _styledComponents.css)(["justify-content:space-evenly;"]);
}, function (props) {
  return (props.align === 'top' || props.align === 'flex-start') && (0, _styledComponents.css)(["align-items:flex-start;"]);
}, function (props) {
  return props.align === 'center' && (0, _styledComponents.css)(["align-items:center;"]);
}, function (props) {
  return props.align === 'bottom' && (0, _styledComponents.css)(["align-items:flex-end;"]);
}, function (props) {
  return props.align === 'baseline' && (0, _styledComponents.css)(["align-items:baseline;"]);
}, function (props) {
  return props.alignContent === 'flex-start' && (0, _styledComponents.css)(["align-content:flex-start;"]);
}, function (props) {
  return props.alignContent === 'flex-end' && (0, _styledComponents.css)(["align-content:flex-end;"]);
}, function (props) {
  return props.alignItems === 'flex-start' && (0, _styledComponents.css)(["align-items:flex-start;"]);
}, function (props) {
  return props.alignItems === 'flex-end' && (0, _styledComponents.css)(["align-items:flex-end;"]);
}, function (props) {
  return props.alignSelf === 'center' && (0, _styledComponents.css)(["align-self:center;"]);
}, function (props) {
  return props.alignSelf === 'flex-start' && (0, _styledComponents.css)(["align-self:flex-start;"]);
}, function (props) {
  return props.alignSelf === 'flex-end' && (0, _styledComponents.css)(["align-self:flex-end;"]);
}, function (props) {
  return props.center && (0, _styledComponents.css)(["align-items:center;justify-content:center;"]);
}, function (props) {
  return props.flexWrap && (0, _styledComponents.css)(["flex-wrap:wrap;"]);
}, function (props) {
  return props.column && (0, _styledComponents.css)(["flex-direction:column;"]);
}, function (props) {
  return props.flexNone && (0, _styledComponents.css)(["flex:none;"]);
}, function (props) {
  return props.flexGrow && (0, _styledComponents.css)(["flex-grow:", ";"], props.flexGrow);
});
exports.flex = flex;
var position = (0, _styledComponents.css)(["position:", ";"], function (props) {
  return props.position;
});
exports.position = position;
var cursor = (0, _styledComponents.css)(["cursor:", ";"], function (props) {
  return props.pointer && 'pointer';
});
exports.cursor = cursor;
var display = (0, _styledComponents.css)(["display:", ""], function (props) {
  return props.inline && 'inline' || props.inlineFlex && 'inline-flex' || props.inlineBlock && 'inline-block' || props.block && 'block' || props.flex && 'flex';
});
/* Generic flexbox component, can contain flex-items or be wrapped in Row */

exports.display = display;

var Box = _styledComponents["default"].div.withConfig({
  displayName: "StyledLayout__Box",
  componentId: "b9gazd-0"
})(["word-break:break-word;max-width:100%;width:", ";height:", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return props.fullWidth && '100%';
}, function (props) {
  return props.fullHeight && '100%';
}, flex, display, spacing, position, _StyleGuide.bgColor, _StyleGuide.border, cursor, xs, sm, md, lg, xl, xxl);
/* Flex row container for <Box> components that aligns to grid,
applies gutter to immediate children */


exports.Box = Box;

var Row = _styledComponents["default"].div.withConfig({
  displayName: "StyledLayout__Row",
  componentId: "b9gazd-1"
})(["display:flex;flex-wrap:wrap;margin:0 -", ";height:", ";", ";", ";", ";", ";@media (min-width:0px){> ", "{padding-left:", ";padding-right:", ";}}@media (min-width:", "px){> ", "{padding-left:", ";padding-right:", ";}}@media (min-width:", "px){> ", "{padding-left:", ";padding-right:", ";}}@media (min-width:", "px){> ", "{padding-left:", ";padding-right:", ";}}@media (min-width:", "px){> ", "{padding-left:", ";padding-right:", ";}}"], function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.fullHeight && '100%';
}, _StyleGuide.bgColor, _StyleGuide.border, flex, spacing, Box, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.responsiveSmall;
}, Box, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.responsiveMedium;
}, Box, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.responsiveLarge;
}, Box, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.responsiveDesktop;
}, Box, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.spacingXs;
});
/* Main container, max 1200px by default */


exports.Row = Row;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "StyledLayout__Container",
  componentId: "b9gazd-2"
})(["width:100%;max-width:", ";margin:0 auto;padding-left:", ";padding-right:", ";", ";@media (min-width:", "px){padding-left:", ";padding-right:", ";}@media (min-width:", "px){padding-left:", ";padding-right:", ";}"], function (props) {
  return props.fullWidth && '100%' || props.theme.screenMaxWidth;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.spacingSm;
}, _StyleGuide.bgColor, function (props) {
  return props.theme.responsiveMedium;
}, function (props) {
  return props.theme.spacingLg;
}, function (props) {
  return props.theme.spacingLg;
}, function (props) {
  return props.theme.responsiveLarge;
}, function (props) {
  return props.theme.spacingXl;
}, function (props) {
  return props.theme.spacingXl;
});

exports.Container = Container;